import type { JsonValue } from "./document.js";
import type { AssessmentResponseUnbranded } from "./response.js";

/** A response as words: a string as it stands, anything else as its JSON. */
export const responseTextOf = (response: JsonValue): string =>
  typeof response === "string" ? response : JSON.stringify(response);

/** What a comment said, or `null` where it said nothing. */
export const commentOf = (
  comment: AssessmentResponseUnbranded | undefined,
): string | null =>
  typeof comment?.response === "string" && comment.response.trim() !== ""
    ? comment.response
    : null;
